import { Component, OnInit, inject, signal } from "@angular/core";
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Contact } from '../contact';
import { CmspageService } from '../cmspage.service';
import { FormsModule } from '@angular/forms';

@Component({
    standalone: true,
    selector: 'app-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.css'],
    imports: [FormsModule]
})
export class ContactFormComponent implements OnInit {
  private router = inject(Router);
  private cmspageService = inject(CmspageService);
  private titleService = inject(Title);

  title = 'Contact Us';
  model = new Contact();
  readonly submitted = signal(false);
  readonly error = signal({});
  readonly success = signal<any>(undefined);

  ngOnInit() {
    this.titleService.setTitle(this.title);
  }

  onSubmit() {
    this.submitted.set(true);
    return this.cmspageService.contactForm(this.model).subscribe(
      data => this.success.set(data),
      error => this.error.set(error)
    );
  }

  gotoHome() {
    this.router.navigate(['/']);
  }
}
